<template>
  <div :class="{ container: !isMobile, 'pb-70': isMobile }">
    <section class="top-section" style="padding-bottom: 20px">
      <el-button style="width: 100% !important" @click="goToList">
        К Списку водителей
      </el-button>
    </section>

    <el-form ref="formAddDriver" :model="driver">
      <el-row :gutter="0">
        <el-col :span="24">
          <div class="my_container-card">
            <el-card class="box-card driver_add_card">
              <div slot="header" class="clearfix">
                <p style="color: #409eff"><b>Форма добавления водителя</b></p>
              </div>
              <section>
                <el-alert
                  v-show="notes"
                  :title="notes"
                  type="error"
                  show-icon
                />
                <el-row style="margin-bottom: 30px">
                  <el-col :span="24">
                    <p style="text-transform: none; margin-bottom: 6px">ФИО:</p>
                    <el-input
                      v-model="driver.fio"
                      placeholder="Введите Ваше ФИО"
                      @input="toCapital"
                    />
                  </el-col>
                </el-row>

                <el-row style="margin-bottom: 30px">
                  <el-col :span="24">
                    <p style="text-transform: none; margin-bottom: 6px">
                      Номер паспорта:
                    </p>
                    <el-input
                      v-model="driver.passport"
                      placeholder="Укажите номер паспорта (без пробелов)"
                      min="10"
                      max="10"
                      @input="driver.passport = clearSpace(driver.passport)"
                    />
                  </el-col>
                </el-row>
                <el-row style="margin-bottom: 30px">
                  <el-col :span="24">
                    <p style="text-transform: none; margin-bottom: 6px">
                      Водительское удостоверение:
                    </p>
                    <el-input
                      v-model="driver.driver_licence"
                      placeholder="Введите номер водительского удостоверения"
                      @input="
                        driver.driver_licence = clearSpace(
                          driver.driver_licence,
                        )
                      "
                    />
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-button
                      v-if="edit_form"
                      style="width: 100%"
                      type="success"
                      @click="postDriver"
                    >
                      Добавить водителя
                    </el-button>
                  </el-col>
                </el-row>
                <el-collapse-transition>
                  <div v-if="detected_password">
                    <el-row>
                      <el-col :span="24">
                        <p style="text-transform: none; margin-bottom: 6px">
                          Номер телефона:
                        </p>
                        <el-form-item
                          prop="phone"
                          :rules="{
                            required: true,
                            message: 'Введите номер телефона водителя',
                            trigger: 'blur',
                          }"
                        >
                          <el-input
                            v-model="driver.phone"
                            v-mask="'+7 (###) ###-##-##'"
                            placeholder="Введите номер телефона"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row style="margin-bottom: 30px">
                      <el-col :span="24">
                        <p style="text-transform: none; margin-bottom: 6px">
                          Удостоверение личности:
                        </p>
                        <upload-document-modal
                          ref="uploadDocumentModal"
                          name-document="Паспорт водителя"
                          :data-edit="documents.driver"
                          :source-id="documents.driver.sourceId"
                          :need-additional="false"
                        />
                      </el-col>
                    </el-row>
                  </div>
                </el-collapse-transition>
              </section>
              <div v-if="detected_password">
                <el-button
                  style="margin-top: 20px; width: 100% !important"
                  type="success"
                  @click="updateDriver"
                >
                  Сохранить
                </el-button>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { CREATE_DRIVER_ON_REQUEST } from '@/store/actions/responseRequest'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { capital_letter } from '@/helpers/functions'
import { filesValidateMixinChildActions } from '@/mixins/filesValidateMixin'
import { hints } from '@/datas/consts'
import { mapMutations } from 'vuex'
import UploadDocumentModal from '@/components/Upload/UploadDocumentModal'

const Driver = RepositoryFactory.get('driver')

export default {
  name: 'DriverAddInProgress',
  components: {
    UploadDocumentModal,
  },

  mixins: [filesValidateMixinChildActions],
  props: {
    carrierName: {
      type: String,
      default: '',
    },
    carrierInn: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      edit_form: true,
      detected_password: false,
      driver: {
        fio: '',
        driver_licence: '',
        passport: '',
        phone: '',
        carrier_inn: '',
        carrier_name: '',
        user_org_inn: '',
      },
      documents: {
        driver: {
          sourceModelName: 'drivers',
          sourceId: 0,
          documentType: 'passport',
        },
      },
      helper: [],
      defaultHelpTitle: hints.default,
      source_id: 0,
      notes: '',
      dialogVisible: false,
      editDriver: {},
      filesValidateMixinData: {
        refComponentName: 'uploadDocumentModal',
        errorMessage: 'удостоверение личности',
        childFilesCountProperty: 'countFiles',
      },
    }
  },
  mounted() {
    const { inn, short_name } = this.userInfo.current.organization

    this.driver.fio =
      short_name && !this.userInfo.profile.has_drivers
        ? this.isIP(short_name)
        : ''
    this.driver.phone = !this.userInfo.profile.has_drivers
      ? this.userInfo.phone
      : ''
    this.driver.carrier_inn = this.carrierInn
    this.driver.carrier_name = this.carrierName
    this.driver.user_org_inn = inn
  },
  methods: {
    ...mapMutations({
      createDriver: `responseRequest/${CREATE_DRIVER_ON_REQUEST}`,
    }),

    isIP(short_name) {
      return short_name.includes('ИП ', 0) ? short_name.substr(3) : ''
    },
    toCapital(val) {
      this.driver.fio = capital_letter(val)
    },
    cleanForm() {
      this.driver.passport = ''
      this.driver.fio = ''
      this.driver.phone = ''
      this.driver.driver_licence = ''
      this.driver.carrier_inn = ''
      this.driver.carrier_name = ''
      this.edit_form = true
      this.detected_password = false
      this.source_id = 0
    },
    checkErrors() {
      if (!this.driver.fio) {
        this.notes = 'ФИО обязательно для заполнения'
      } else if (!this.driver.passport && !this.driver.driver_licence) {
        this.notes =
          'Необходимо заполнить данные паспорта или водительского удостоверения'
      } else if (
        this.driver.passport.length !== 10 &&
        this.driver.passport.length !== 0
      ) {
        this.notes = 'Значение «Passport» должно содержать 10 символов'
      } else if (!this.driver.carrier_inn && Number(this.source_id) !== 0) {
        this.notes = 'Необходимо выбрать перевозчика'
      } else {
        this.notes = ''
      }
    },
    postDriver() {
      this.checkErrors()

      if (!this.notes) {
        Driver.postDriver({
          fio: this.driver.fio,
          driver_licence: this.driver.driver_licence,
          passport: this.driver.passport,
          user_org_inn: this.driver.user_org_inn,
          phone: this.driver.phone,
          carrier_name: this.driver.carrier_name,
          carrier_inn: this.driver.carrier_inn,
        })
          .then(res => {
            if (res.status === 200) {
              this.edit_form = false
              this.documents.driver.sourceId = res.data.driver.id
              this.source_id = res.data.driver.id
              this.detected_password = true

              if (this.isDriverRole) {
                this.$alert(
                  'Водитель добавлен успешно. Добавьте документы к водителя',
                )
              }
            }
          })
          .catch(err => {
            if (err.status === 400 && err.data.errors.passport) {
              this.$confirm(
                'Водитель с таким удостоверением уже существует.\n' +
                  'Перейти к редактированию его данных?',
                '',
                {
                  confirmButtonText: 'Да',
                  cancelButtonText: 'Нет',
                  type: 'warning',
                },
              )
                .then(() => this.goToEditDriver())
                .catch(() => {})
            }
          })
      }
    },
    goToEditDriver() {
      Driver.getDriver().then(res => {
        this.editDriver = res.data.items.find(
          obj => obj.passport === this.driver.passport,
        )
        this.dialogVisible = true
      })
    },
    goToList() {
      this.$emit('close')
    },
    updateDriver() {
      this.checkErrors()

      if (!this.notes && this.checkCountFilesBeforeSaveInOwn()) {
        this.$refs['formAddDriver'].validate(valid => {
          if (valid) {
            Driver.updateDriver(this.source_id, this.driver)
              .then(res => {
                if (res.status === 200) {
                  this.createDriver({ ...res.data?.driver, user_id_match: 0 })

                  if (this.isDriverRole && !this.userInfo.has_drivers) {
                    // this.$store.dispatch(`userProfile/${GET_PROFILE}`)
                    this.$alert('Водитель добавлен успешно', 'Успешно')
                  }
                  this.goToList()
                }
              })
              .catch(err => {
                if (err.status === 400 && err.data.errors.passport) {
                  this.notes = `Значение «Passport» - ${this.driver.passport} уже существует`
                }
              })
          }
        })
      }
    },
    // setCarrier(data) {
    //   this.driver.carrier_inn = data.carrier_inn
    //   this.driver.carrier_name = data.carrier_name
    // },
  },
}
</script>

<style lang="sass" scoped>
.driver_add_card
  .compact-field
    display: flex
  .empty-p
    height: 18px
  .driver-buttons-block
     display: flex
     justify-content: flex-end
</style>
